import { Modal, Table } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { ButtonFilled } from "reusableComponent/UIButtons";
import React from "react";
import styled from "styled-components";

const Body = styled.div`
  text-align: center;

  .icon-circle {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #ff4d4f;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin: 0 auto 20px;
  }

  .counts {
    text-align: left;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .explainer {
    text-align: left;
    color: #636980;
    margin-bottom: 16px;
  }

  .ant-table-wrapper {
    text-align: left;
    margin-bottom: 20px;
  }
`;

const columns = [
  { title: "S.No", dataIndex: "sno", key: "sno", width: 70 },
  { title: "Name", dataIndex: "fullname", key: "fullname" },
  { title: "Employee ID", dataIndex: "employeeid", key: "employeeid" },
];

const GenerateListModal = ({ open, onClose, result }) => {
  const generated = result?.generated ?? 0;
  const skipped = result?.skipped ?? [];

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered>
      <Body>
        <div className="icon-circle">
          <ExclamationCircleFilled />
        </div>
        <div className="counts">
          <div>List Generated: {generated}</div>
          <div>List not generated: {skipped.length}</div>
        </div>
        {skipped.length > 0 && (
          <>
            <p className="explainer">
              The employees listed below have pending appraisals from the previous cycle. New
              contracts cannot be generated until previous appraisals have been closed.
            </p>
            <Table
              columns={columns}
              dataSource={skipped.map((row, idx) => ({ ...row, sno: idx + 1 }))}
              pagination={false}
              rowKey={(row) => row.sno}
            />
          </>
        )}
        <ButtonFilled type="primary" onClick={onClose} style={{ float: "right" }}>
          Got it
        </ButtonFilled>
      </Body>
    </Modal>
  );
};

export default GenerateListModal;
